<script>
import { Editor } from "@tiptap/vue-2";
import Table from '@tiptap/extension-table';
import TableHeader from '@tiptap/extension-table-header';
import TableRow from '@tiptap/extension-table-row';
import { TableCellCustom } from "plant-common/src/components/PRichText/extensions/tableCell";
import StarterKit from "@tiptap/starter-kit";
import TextStyle from "@tiptap/extension-text-style";
import TextAlign from '@tiptap/extension-text-align';
import { Color } from "@tiptap/extension-color";
import FontFamily from "@tiptap/extension-font-family";
import Underline from "@tiptap/extension-underline";
import Subscript from "@tiptap/extension-subscript";
import Superscript from "@tiptap/extension-superscript";
import HardBreak from "@tiptap/extension-hard-break";
import { Fields } from "../../_components/extensions/tiptap/Fields.js";
import { OrderListClass, Clipboard, FormulaMark, FormulaClass, FontSize } from "plant-common";
import _ from "lodash";

export default {
  name: "MixinRichText",
  data() {
    return {
      textEdit: false
    }
  },
  methods: {
    setEditor(data, notEditable = false) {
      const editor = new Editor({
        editable: !notEditable,
        onUpdate: _.debounce(() => {
          data.html = editor.getHTML();
        }, 300),
        extensions: [
          FontSize,
					TableCellCustom,
          StarterKit,
          TextStyle,
          TextAlign.configure({
						types: ['paragraph']
					}),
          Table.configure({
						resizable: true,
					}),
					TableRow,
					TableHeader,
          Color,
          FontFamily,
          Subscript,
          Superscript,
          Underline,
          Fields,
          OrderListClass,
          Clipboard,
          HardBreak,
          FormulaMark,
          FormulaClass
        ],
        autofocus: true,
        content: data.html
      });

      return editor
    }
  }
}
</script>
